import { RateSource } from '@/modules/common/types/rate-source';

export interface ProjectTeamMember {
  id: string;
  name: string;
  email?: string;
  avatarLink?: string;
  department?: string;
  type: ProjectTeamMemberType;
  // Rate values for different sources
  userExternalRateValue?: number;
  seniorityBasedRateValue?: number;
  roleBasedRateValue?: number;
  globalDefaultRateValue?: number;
  projectRateCardValue?: number;
  customRateValue?: number;
  // Current active rate source
  activeRateSource: RateSource;
}

export enum ProjectTeamMemberType {
  HasAssignments = 'hasAssignments',
  ManuallyAdded = 'manuallyAdded',
}
